import { getTariffRates } from 'utils/TariffRatesAPIUtils';
import tariffStore from 'stores/TariffRatesStore';
import { getAccessorialRates } from 'utils/AccessorialRatesAPIUtils';
import accessorialStore from 'stores/AccessorialRatesStore';
const _ = require('underscore');
export default function (contract) {
    let isValidate = {
        value: true,
        info: '',
    };
    if (contract._id) {
        getTariffRates(contract._id);
        getAccessorialRates(contract._id);
    }
    if (_.isEmpty(contract.tariff_rates)) {
        isValidate = {
            value: false,
            info: 'Tariff rate should not be empty!',
        };
        return isValidate;
    }
    for (const tariffRate of tariffStore.getTariffRates()) {
        if (!tariffRate.is_ready) {
            isValidate = {
                value: false,
                info: 'Tariff rate ' + tariffRate.name + ' is not completed or have invalid value.',
            };
            return isValidate;
        }
    }
    if (_.isEmpty(contract.accessorial_rates)) {
        isValidate = {
            value: false,
            info: 'Accessorial rate should not be empty!',
        };
        return isValidate;
    }
    for (const accessorialRate of accessorialStore.getAccessorialRates()) {
        if (!accessorialRate.is_ready) {
            isValidate = {
                value: false,
                info: 'Accessorial rate ' + accessorialRate.name + ' is not completed or have invalid value.',
            };
            return isValidate;
        }
    }
    if ((!contract.term) || (contract.term <= 0)) {
        isValidate = {
            value: false,
            info: 'Contract term should be set to more than 0.',
        };
        return isValidate;
    }
    return isValidate;
}
